import { render, staticRenderFns } from "./CircleGradient.vue?vue&type=template&id=4838e031&"
import script from "./CircleGradient.vue?vue&type=script&lang=js&"
export * from "./CircleGradient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports